export const beneficiaryDashboardTranslations = {
    en: {
        // Process Steps
        totalBeneficiary: "Total Beneficiary",
        preRegistration: "Pre-Registration",
        registration: "Registration",
        doctorScreening: "Doctor Screening",
        firstOpd: "First OPD",
        pharmacy: "Pharmacy",
        mukhyamantriHridaySanjivani: "Mukhyamantri Hriday Sanjivani",
        hllBloodTest: "Diagnostic Test",
        abhaCard: "ABHA Card",
        hospitalReferral: "Hospital Referral",
        schemesInfo: "Schemes Info",

        // Chart Titles
        ageWiseBeneficiariesCount: "Age-wise Beneficiaries Count",
        genderWiseBeneficiariesDistribution: "Gender-wise Beneficiaries Distribution",
        diseaseWiseBeneficiariesCount: "Disease-wise Beneficiaries Count",
        activityWiseBeneficiariesCount: "Activity-wise Beneficiaries Count",

        // Gender Labels
        male: "Male",
        female: "Female",
        other: "Other",

        // Module Names for Empty States
        ageWiseBeneficiariesModule: "Age-wise Beneficiaries Count",
        genderWiseBeneficiariesModule: "Gender-wise Beneficiaries Distribution",
        diseaseWiseBeneficiariesModule: "Disease-wise Beneficiaries Count",
        activityWiseBeneficiariesModule: "Activity-wise Beneficiaries Count",

        // Follow-up Status
        followupStatusWiseCount: "Hospital Follow-ups",
        followupStatusWiseSubtitle: "Beneficiary distribution by current follow-up status",
        followupStatusDetails: "Status Details",
        followupStatusDetailsSubtitle: "Counts per beneficiary follow-up status",
        loading: "Loading...",
        exportExcel: "Export Excel",

        // Camp-type filter labels
        generalHealthCamp: "General Health Camp",
        eyeCamp: "Eye Camp",
        cancerCamp: "Cancer Camp",
    },
    mr: {
        // Process Steps
        totalBeneficiary: "एकूण लाभार्थी",
        preRegistration: "पूर्व-नोंदणी",
        registration: "नोंदणी",
        doctorScreening: "डॉक्टर तपासणी",
        firstOpd: "पहिले ओपीडी",
        pharmacy: "फार्मसी",
        mukhyamantriHridaySanjivani: "मुख्यमंत्री हृदय संजीवनी",
        hllBloodTest: "HLL(रक्त तपासणी)",
        abhaCard: "आभा कार्ड",
        hospitalReferral: "रुग्णालय संदर्भ",
        schemesInfo: "योजना माहिती",

        // Chart Titles
        ageWiseBeneficiariesCount: "वयानुसार लाभार्थी संख्या",
        genderWiseBeneficiariesDistribution: "लिंगानुसार लाभार्थी वितरण",
        diseaseWiseBeneficiariesCount: "रोगानुसार लाभार्थी संख्या",
        activityWiseBeneficiariesCount: "क्रियाकलापानुसार लाभार्थी संख्या",

        // Gender Labels
        male: "पुरुष",
        female: "महिला",
        other: "इतर",

        // Module Names for Empty States
        ageWiseBeneficiariesModule: "वयानुसार लाभार्थी संख्या",
        genderWiseBeneficiariesModule: "लिंगानुसार लाभार्थी वितरण",
        diseaseWiseBeneficiariesModule: "रोगानुसार लाभार्थी संख्या",
        activityWiseBeneficiariesModule: "क्रियाकलापानुसार लाभार्थी संख्या",

        // Follow-up Status
        followupStatusWiseCount: "रुग्णालय फॉलो-अप",
        followupStatusWiseSubtitle: "सध्याच्या फॉलो-अप स्थितीनुसार लाभार्थी वितरण",
        followupStatusDetails: "स्थिती तपशील",
        followupStatusDetailsSubtitle: "प्रत्येक लाभार्थी फॉलो-अप स्थितीची संख्या",
        loading: "लोड होत आहे...",
        exportExcel: "एक्सेल निर्यात करा",

        // Camp-type filter labels
        generalHealthCamp: "सामान्य आरोग्य शिबिर",
        eyeCamp: "नेत्र शिबिर",
        cancerCamp: "कर्करोग शिबिर",
    }
};
